import { defineModule } from '@portal/kernel';

export const manifest = defineModule({
  key: 'core-organization',
  version: '0.1.0',
  kind: 'core',
  coreVersion: '^0.1.0',
  name: { vi: 'Tổ chức', en: 'Organization' },
  description: {
    vi: 'Cơ cấu tổ chức dạng cây, chức danh, hồ sơ nhân viên và quan hệ quản lý.',
    en: 'Organisation tree, job titles, employee profiles and reporting lines.',
  },
  dependsOn: ['core-system', 'core-audit', 'core-identity'],
  database: { schema: 'core_org' },
  permissions: [
    {
      key: 'core-organization.unit.view',
      name: { vi: 'Xem sơ đồ tổ chức', en: 'View org chart' },
      defaultGranted: true,
    },
    {
      key: 'core-organization.unit.manage',
      name: { vi: 'Quản lý đơn vị tổ chức', en: 'Manage org units' },
    },
    {
      key: 'core-organization.employee.view',
      name: { vi: 'Xem danh bạ nhân viên', en: 'View employee directory' },
      defaultGranted: true,
      dataScopes: ['own', 'department', 'department_tree', 'tenant'],
    },
    {
      key: 'core-organization.employee.manage',
      name: { vi: 'Quản lý hồ sơ nhân viên', en: 'Manage employees' },
      // Unit heads manage their own sub-tree; HR manages the whole company. Creating employees needs `tenant`.
      dataScopes: ['department', 'department_tree', 'tenant'],
    },
    {
      key: 'core-organization.job-title.view',
      name: { vi: 'Xem chức danh', en: 'View job titles' },
      defaultGranted: true,
    },
    {
      key: 'core-organization.job-title.manage',
      name: { vi: 'Quản lý chức danh', en: 'Manage job titles' },
    },
  ],
  navigation: [
    {
      id: 'org',
      label: { vi: 'Tổ chức', en: 'Organization' },
      icon: 'building',
      order: 50,
      children: [
        {
          id: 'org.chart',
          label: { vi: 'Sơ đồ tổ chức', en: 'Org chart' },
          icon: 'building',
          path: '/org/chart',
          permission: 'core-organization.unit.view',
          order: 10,
        },
        {
          id: 'org.employees',
          label: { vi: 'Nhân viên', en: 'Employees' },
          icon: 'users',
          path: '/org/employees',
          permission: 'core-organization.employee.view',
          order: 20,
        },
        {
          id: 'org.job-titles',
          label: { vi: 'Chức danh', en: 'Job titles' },
          icon: 'clipboard-list',
          path: '/org/job-titles',
          permission: 'core-organization.job-title.view',
          order: 30,
        },
      ],
    },
  ],
});
